"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredPackagesMissingError = exports.EmptyManifestError = exports.PythonPluginErrorNames = void 0;
var PythonPluginErrorNames;
(function (PythonPluginErrorNames) {
    PythonPluginErrorNames["EMPTY_MANIFEST_ERROR"] = "EMPTY_MANIFEST_ERROR";
    PythonPluginErrorNames["REQUIRED_PACKAGES_MISSING_ERROR"] = "REQUIRED_PACKAGES_MISSING_ERROR";
})(PythonPluginErrorNames = exports.PythonPluginErrorNames || (exports.PythonPluginErrorNames = {}));
class EmptyManifestError extends Error {
    constructor(message) {
        super(message);
        this.name = PythonPluginErrorNames.EMPTY_MANIFEST_ERROR;
    }
}
exports.EmptyManifestError = EmptyManifestError;
class RequiredPackagesMissingError extends Error {
    constructor(message) {
        super(message);
        this.name = PythonPluginErrorNames.REQUIRED_PACKAGES_MISSING_ERROR;
    }
}
exports.RequiredPackagesMissingError = RequiredPackagesMissingError;
//# sourceMappingURL=errors.js.map